import { Form, Radio } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { OnboardingValues } from '~/agents/salesAssistant/common'
import { SelectProviderAccount } from '~/features/formConfiguration/client/components/CustomInputs/SelectProviderAccount'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'

type Props = StepProps

export const StepConnection: React.FC<Props> = props => {
  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4}>Connect Your Inbox</TitlePrimary>

        <Form.Item
          name={['emailServices', 'provider']}
          label="Which email provider do you want to use?"
          rules={[{ required: true }]}
        >
          <Radio.Group
            optionType="button"
            buttonStyle="solid"
            options={[
              {
                label: 'Google',
                value: 'google',
              },
              {
                label: 'Outlook',
                value: 'outlook',
              },
              {
                label: 'IMAP',
                value: 'nylas',
              },
            ]}
          />
        </Form.Item>

        <Form.Item<OnboardingValues> shouldUpdate={true}>
          {options => {
            const provider = options.getFieldValue([
              'emailServices',
              'provider',
            ])

            if (provider === 'nylas') {
              return (
                <Form.Item
                  name={['emailServices', 'accountNylas']}
                  label="IMAP Account"
                >
                  <SelectProviderAccount providerKey="nylas" />
                </Form.Item>
              )
            }

            if (provider === 'google') {
              return (
                <Form.Item
                  name={['emailServices', 'accountGmail']}
                  label="Gmail Account"
                >
                  <SelectProviderAccount providerKey="gmail" />
                </Form.Item>
              )
            }

            if (provider === 'outlook') {
              return (
                <Form.Item
                  name={['emailServices', 'accountOutlookMail']}
                  label="Outlook Account"
                >
                  <SelectProviderAccount providerKey="outlookMail" />
                </Form.Item>
              )
            }
          }}
        </Form.Item>
      </CommonClient.Onboarding.Step>
    </>
  )
}
